export default "__VITE_ASSET__ac348ed8__"